import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=5bcbed99&scoped=true&"
import script from "./Process.vue?vue&type=script&lang=ts&"
export * from "./Process.vue?vue&type=script&lang=ts&"
import style0 from "./Process.vue?vue&type=style&index=0&id=5bcbed99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbed99",
  null
  
)

export default component.exports